<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { GpTooltip } from '@gportal/uikit';
import { computed } from 'vue';

// internalDomains is a list of domains we have control over and
// consider "internal".
const internalDomains = [
  'contabo.com', // GPCORE is part of Contabo
  'g-portal.com', // GPCORE is part of GPORTAL
  'gpcore.io', // Live environment
  'gpcloud.space', // Dev environment
];

const { url, openInNewTab = true } = defineProps<{
  url: string;
  openInNewTab?: boolean;
}>();

// isInternalLink checks if the given URL is an internal domain we
// have control over. This is used to mark external links as such.
const isInternalLink = computed(() => {
  return internalDomains.some((domain) => url.includes(domain));
});
</script>
<template>
  <a
    v-if="isInternalLink"
    :href="url"
    :target="openInNewTab ? '_blank' : ''"
    class="tw-whitespace-nowrap tw-break-words"
  >
    <slot />
    <FontAwesomeIcon :icon="['fas', 'fa-arrow-up-right-from-square']" class="tw-ml-1 tw-text-sm" />
  </a>
  <GpTooltip
    v-else
    content="This link is redirecting to a domain outside of GPCORE. Keep in mind that GPCORE has no control over it and therefore not responsible for the content and availability of this resource."
    trigger="hover"
  >
    <a
      :href="url"
      class="tw-whitespace-nowrap tw-break-words"
      :target="openInNewTab ? '_blank' : ''"
    >
      <slot />
      <FontAwesomeIcon
        :icon="['fas', 'fa-arrow-up-right-from-square']"
        class="tw-ml-1 tw-text-sm"
      />
    </a>
  </GpTooltip>
</template>
